import { DiscountType, SaleType, } from "@wix/ambassador-devcenter-managedapps-v1-managed-app/types";
export const getDiscountAmount = (app) => app?.pricingDetails?.discount?.amount;
export const getSaleType = (app) => app?.pricingDetails?.discount?.saleInfo?.saleType;
export const getIsDiscountTypeIsPercentage = (app) => app?.pricingDetails?.discount?.type === DiscountType.PERCENTAGE;
export const getIsDevSale = (app) => app?.pricingDetails?.discount?.saleInfo?.saleType === SaleType.DEVELOPER_SALE;
//# sourceMappingURL=managedApp.js.map